import {SearchModel} from "@fedeltapointofsale/data-client";
import {Injectable, Injector} from "@angular/core";
import {MixAndMatchInclusionSearchData} from "./mix-and-match-inclusion-search.data";

@Injectable()
export class MixAndMatchInclusionSearchModel extends SearchModel<MixAndMatchInclusionSearchData> {
    constructor(injector: Injector) {
        super(injector, MixAndMatchInclusionSearchData);
    }
}
